module.exports = __webpack_public_path__ + "media/images/about-logo-prag-0c886acba031eec6232d096c9f7178f0.png";